// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"47":"662cefad","96":"c4575acd"}[chunkId] + ".chunk.css";
};